import React from "react";

export const MultistepProgress = ({
  steps, //array
  currentStep, //0 index
  containerStyle,
  animationDuration = ".75s",
  incompleteColor = "rgb(120,120,120)",
  completedColor = "rgb(20,200,20)",
  barHeight = "5px",
  ...props
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        ...containerStyle,
      }}
      {...props}
    >
      {steps.map((step, index) => {
        return (
          <React.Fragment key={index}>
            {step}
            {index < steps.length - 1 && (
              <div
                style={{
                  position: "relative",
                  flex: 1,
                  height: barHeight,
                  backgroundColor: incompleteColor,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: currentStep > index ? 0 : "110%",
                    bottom: 0,
                    transitionDuration: animationDuration,
                    backgroundColor: completedColor,
                  }}
                ></div>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
